<template>
  <div
    class="d-flex flex-column align-center justify-center"
    data-qa="card_getting_preloader"
    :style="styleProps"
  >
    <v-progress-circular
      indeterminate
      :size="componentData.circleSize"
      :width="componentData.circleWidth"
      class="primary--text d-block mx-auto"
      data-qa="card_getting_preloader_progress"
    />
    <div
      v-if="useText"
      class="text-body-1 text--text mt-6"
      data-qa="card_getting_preloader_text"
    >
      Проверяем...
    </div>
  </div>
</template>

<script>
import { getStyleData } from 'www/vue_components/common/Club/components/core/ClubCardGetting/interfaces'

export default {
  name: 'ClubCardGettingPreloader',
  props: {
    styleProps: {
      type: Object,
      default: getStyleData,
    },
    useText: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    componentData: {
      circleWidth: window.MOBILE_VERSION ? 2 : 3,
      circleSize: window.MOBILE_VERSION ? 41 : 82,
    },
  }),
}
</script>
